
import { Options } from "vue-class-component";
import ComponentMixins from "../ComponentMixins";

@Options({
    name: "flowable-common-form-components-money-input",
})
export default class MoneyInput extends ComponentMixins {}
